import { navigationSlice } from '../reducers/navigation.reducers'

export const {
  clearNavigationStateAction,
  hideBlockNavigationModalAction,
  setNavigationStateAction,
  showBlockNavigationModalAction,
} = navigationSlice.actions
